import { useState, useEffect } from 'react';

const useIframeParams = (paramName:any) => {
    
    const [paramValue, setParamValue] = useState('');

    useEffect(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const value = urlParams.get(paramName) || '';
      setParamValue(value);
    }, [paramName]);
  
    return paramValue;
};

export default useIframeParams;
